import { useNavigate } from "react-router-dom";
import CheckCircle from "@mui/icons-material/CheckCircle";
import "../Login/login.css";

const PasswordUpdated = () => {
  const navigate = useNavigate();

  return (
    <div className="hf-login-root">
      <div className="hf-login-shell">
        <div className="hf-login-brand">
          <img
            className="hf-login-brand-logo"
            src="/img/hitfitlogo.jpg"
            alt="HitFit"
          />
          <h2 className="hf-login-brand-heading">
            Vođeni treninzi za rekreativce
          </h2>
        </div>

        <div className="hf-login-card">
          <div className="hf-login-card-inner hf-login-status-body">
            <div className="hf-login-logo-wrap">
              <img
                className="hf-login-logo"
                src="/img/hitfitlogo.jpg"
                alt="HitFit"
              />
            </div>

            <div className="hf-login-status-icon hf-login-status-success">
              <CheckCircle fontSize="inherit" />
            </div>

            <h1 className="hf-login-title">Lozinka je ažurirana</h1>
            <p className="hf-login-subtitle">
              Vaša lozinka je uspešno ažurirana. Sada možete da se prijavite
              novom lozinkom.
            </p>

            <div className="hf-login-actions">
              <button
                type="button"
                className="hf-login-submit"
                onClick={() => navigate("/login")}
              >
                Nazad na prijavu
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordUpdated;
